<template>
    <cart></cart>
</template>

<script>
    const store = require('../store/').default;
    const {ACTION} = require('../store/action-types');
    const Cart = require('./Cart');

    export default {
        components: {
            Cart,
        },
        data: function() {
            return store.state
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/cart/components/App.vue